import fgInput from './common/components/inputs/formGroupInput.vue'
import DropDown from './common/components/Dropdown.vue'
import Card from './common/components/cards/Card.vue'
import Button from './common/components/Button.vue'
import {Input, InputNumber, Tooltip, Popover} from 'element-ui'
import numInput from './common/components/inputs/OciNumberInput.vue'
//import currencyInput from './common/components/inputs/OciCurrencyInput.vue'
import dateInput from './common/components/inputs/OciDateInput.vue'
import customSelect from './common/components/customSelect.vue'
import maskInput from './common/components/inputs/maskInput.vue'

import crypto from '@/common/resources/crypto.js'
import ociUtils from '@/common/resources/ociUtils.js';
import ConditionSetTable from "@/broker/components/conditionsComponents/ConditionSetTable";

import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css';

import dropdown from './common/components/inputs/DropdownInput';
import currencyInput from './common/components/inputs/currencyInput.vue';
import * as accounting from 'accounting-js'
import vClickOutside from 'v-click-outside'

import ociDropdowns from './common/resources/dropdowns'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import InfiniteLoading from 'vue-infinite-loading';


/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */


import VueApexCharts from 'vue-apexcharts'

const GlobalComponents = {
  install (Vue) {
    Vue.component('accounting', accounting);
    Vue.component('ConditionSetTable', ConditionSetTable);
    Vue.component('dropdown', dropdown);
    Vue.component('mask-input', maskInput);
    Vue.component('fg-input', fgInput);
    Vue.component('drop-down', DropDown);
    Vue.component('card', Card);
    Vue.component('n-button', Button);
    Vue.component('num-input', numInput);
    Vue.component('currency-input', currencyInput);
    Vue.component('date-input', dateInput);
    Vue.component('custom-select', customSelect);
    Vue.component('vue-phone-number-input', VuePhoneNumberInput);
    Vue.component('vue-tel-input', VueTelInput);
    Vue.component(Input.name, Input);
    Vue.use(VueApexCharts);
    Vue.component('apexchart', VueApexCharts)

    Vue.component(InputNumber.name, InputNumber);
    Vue.use(Tooltip);
    Vue.use(Popover);
    Vue.use(crypto);
    Vue.use(ociUtils);

    Vue.use(vClickOutside)
    //Vue.use(dropdownCustom);
    Vue.use(ociDropdowns);
    Vue.use(InfiniteLoading, { /* options */
      props:{
        distance:10
      }});
  }
};

export default GlobalComponents
